import React from "react";
import { cn } from "@/lib/utils";

export const GlassPanel = React.forwardRef(({ className = "", children, hover = false, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("glass rounded-2xl", hover && "glass-hover", className)}
    {...props}
  >
    {children}
  </div>
));
GlassPanel.displayName = "GlassPanel";

export default GlassPanel;
